module.exports = __webpack_public_path__ + "static/img/img-1.91e98ccb.png";